var service = {
    auth: 'https://percko-waviigroupsservice.getwavii.co',//'http://localhost:6000',
    single: 'https://percko-waviiuserstatsservice.getwavii.co',//'http://localhost:5005',
    group: 'https://percko-waviigroupsservice.getwavii.co',//'http://localhost:6000',
}
export default service
